var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllPatients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43_1964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 12.1875C20.4461 12.1868 21.3794 12.4067 22.2257 12.8299C23.072 13.253 23.8079 13.8677 24.375 14.625",
    stroke: "#454551",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.625 14.625C2.19212 13.8677 2.92805 13.253 3.77431 12.8299C4.62057 12.4067 5.55385 12.1868 6.5 12.1875",
    stroke: "#454551",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 18.6875C15.2437 18.6875 17.0625 16.8687 17.0625 14.625C17.0625 12.3813 15.2437 10.5625 13 10.5625C10.7563 10.5625 8.9375 12.3813 8.9375 14.625C8.9375 16.8687 10.7563 18.6875 13 18.6875Z",
    stroke: "#454551",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3125 21.9375C7.89576 20.9477 8.72723 20.1273 9.72471 19.5573C10.7222 18.9873 11.8512 18.6875 13 18.6875C14.1488 18.6875 15.2778 18.9873 16.2753 19.5573C17.2728 20.1273 18.1042 20.9477 18.6875 21.9375",
    stroke: "#454551",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3516 8.125C16.5035 7.53651 16.8174 7.00242 17.2577 6.58339C17.6979 6.16435 18.2469 5.87717 18.8421 5.75444C19.4374 5.63172 20.0552 5.67838 20.6252 5.88912C21.1953 6.09986 21.6949 6.46624 22.0672 6.94664C22.4395 7.42705 22.6697 8.00223 22.7315 8.60687C22.7933 9.2115 22.6844 9.82136 22.417 10.3672C22.1496 10.913 21.7346 11.3729 21.2189 11.6947C20.7033 12.0165 20.1078 12.1872 19.5 12.1875",
    stroke: "#454551",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.49995 12.1875C5.89216 12.1872 5.29664 12.0165 4.78101 11.6947C4.26538 11.3729 3.85031 10.913 3.58294 10.3672C3.31557 9.82136 3.20662 9.2115 3.26845 8.60687C3.33028 8.00223 3.56042 7.42705 3.93274 6.94664C4.30505 6.46624 4.80462 6.09986 5.37471 5.88912C5.94479 5.67838 6.56255 5.63172 7.15782 5.75444C7.75309 5.87717 8.30202 6.16435 8.74227 6.58339C9.18252 7.00242 9.49644 7.53651 9.64839 8.125",
    stroke: "#454551",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43_1964"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllPatients);
export default __webpack_public_path__ + "static/media/all-patients.7aaaecc3fbd4a7ab35b1397e83c257d2.svg";
export { ForwardRef as ReactComponent };